import React from 'react'

export const Loader = () => <div>Loading...</div>

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js